import React from 'react'

const CoreCopy = ({content3}) => {
  return (
    <div>
         <div className="row mt-60 mart30 d-flex   justify-content-center ">
          {content3.map((val, i) => (
            <div key={i} className="col-lg-4 col-md-6    " style={{marginBottom:50}}>
              <div className="border-card p-3  h-100  text-center  transform-rotate" >
              <div className='img d-flex align-items-md-center justify-content-center'>
                <img src={val.icon} alt="" style={{ width: 40, height: 40 }} />

                </div>
                <div>
                  <h3 className="h3-heading lh-base  fs-4 mb-2 mt-3 pt-1">{val.title}</h3>
                  <p className="h3-para lh-base fs-6">{val.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

    </div>
  )
}

export default CoreCopy